module.exports = __webpack_public_path__ + "img/logo-3.b698b691.svg";